export const GET_EMPLOYEES = "GET_EMPLOYEES";
export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE";
export const DELETE_EMPLOYEES = "DELETE_EMPLOYEES";
